import axios from "axios";
import Cookies from "js-cookie";
import { message } from "antd";
import AuthStore from "../../stores/AuthStore";

axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (err) => {
    if (err?.response?.status === 401) {
      AuthStore.clearLocalStorage();
      message.error("Token过期,请重新登录");
      setTimeout(() => {
        document.location.href = "/sso/login";
      }, 1000);
    }
    // err?.response?.data?.message ? message.error(err.response.data.message): message.error(err.message)
  }
);

const SystemKey = window.CONFIG.systemKey;

export function getTokenHeaders() {
  const token = localStorage.getItem(`${SystemKey}-token`) ?? "";

  return {
    token,
  };
}

interface ResponseData<T = any> {
  total?: number | undefined;
  code: number;
  message: string;
  rows?: T;
  data?: T;
}

export async function post<T = any>(url: string, data?: any, withToken = false): Promise<ResponseData<T> | undefined> {
  try {
    const res = await axios.post(url, data, {
      headers: {
        ...(withToken ? getTokenHeaders() : {}),
      },
    });
    return res as any;
  } catch (e) {
    console.log(e);
  }
}

export async function get<T = any>(url: string, params?: any, withToken = false): Promise<ResponseData<T> | undefined> {
  try {
    const res = await axios
      .get(url, {
        params,
        headers: {
          ...(withToken ? getTokenHeaders() : {}),
        },
      })
      .catch((e) => {
        console.log(e, "error11111");
      });
    return res as any;
  } catch (e) {
    console.log(e, "error22222");
  }
}
